import styled from "@emotion/styled";

import { ColorProp, getColorFromTheme } from "../../../styles/themes";

type DividerProps = {
  color?: ColorProp;
  margin?: string;
  type?: "horizontal";
  // opt-in: this is a 1px-height div, not a border, so a flex-column parent
  // can shrink it to 0 under overflow. Set this where that's happened.
  noShrink?: boolean;
};

const Divider = styled.div<DividerProps>(
  ({ theme, color, margin, type = "horizontal", noShrink }) => ({
    backgroundColor: getColorFromTheme(color, theme) ?? theme.colors.sysBorderDecorative,
    ...(type === "horizontal" && {
      width: "100%",
      height: 1,
      margin: margin ?? "8px 0",
      ...(noShrink && { flexShrink: 0 }),
    }),
  }),
);

export default Divider;
